import _ from 'lodash';

/**
 * Matches string by name, user, uid, or phone number
 * @param {Object} contact - The contact object containing phone numbers.
 * @param {string} str - The string to match against contact information.
 * @returns {string} - Returns 'work', 'home', 'mobile', 'extension', or 'unknown'.
 */
export default function matchContactType(contact, str) {
  if (!str || !contact) {
    return 'unknown';
  }

  // Normalize the input string (remove spaces and leading +)
  const normalize = (value) => _.trim(value).replace(/^\+/, '');

  const normalizedStr = normalize(str);

  // List of possible phone number fields
  const phoneTypes = {
    mobile: _.get(contact, 'cell_phone', ''),
    work: _.get(contact, 'work_phone', ''),
    home: _.get(contact, 'home_phone', ''),
    extension: _.get(contact, 'extension', ''),
  };

  // Find the first matching key
  return _.findKey(phoneTypes, (phone) => normalize(phone) === normalizedStr) || 'unknown';
}
